<template>
  <logic-storage-report />
</template>

<script>
import LogicStorageReport from '@/components/Reports/LogicStorageReport'

export default {
  components: {
    LogicStorageReport
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// LogicStorage.vue?0b1df77b